import { render, staticRenderFns } from "./EmailTemplateEdit.vue?vue&type=template&id=5470acef&scoped=true&"
import script from "./EmailTemplateEdit.vue?vue&type=script&lang=js&"
export * from "./EmailTemplateEdit.vue?vue&type=script&lang=js&"
import style0 from "./EmailTemplateEdit.vue?vue&type=style&index=0&id=5470acef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5470acef",
  null
  
)

export default component.exports